import React from 'react';
interface InputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label?: string;
  error?: string;
  icon?: React.ReactNode;
}
export function Input({
  label,
  error,
  icon,
  className = '',
  ...props
}: InputProps) {
  return <div className="w-full" data-id="element-1333">
      {label && <label className="block text-sm font-medium text-gray-700 mb-1.5" data-id="element-1334">
          {label}
        </label>}
      <div className="relative" data-id="element-1335">
        {icon && <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400 pointer-events-none" data-id="element-1336">
            {icon}
          </div>}
        <input className={`
            w-full rounded-xl border border-gray-200 bg-gray-50 px-4 py-3 text-gray-900 placeholder-gray-400
            focus:border-purple-500 focus:bg-white focus:outline-none focus:ring-2 focus:ring-purple-500/20 transition-all
            ${icon ? 'pl-10' : ''}
            ${error ? 'border-red-300 bg-red-50 focus:border-red-500 focus:ring-red-500/20' : ''}
            ${className}
          `} {...props} data-id="element-1337" />
      </div>
      {error && <p className="mt-1.5 text-xs text-red-600 font-medium" data-id="element-1338">{error}</p>}
    </div>;
}